import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const RightArrow12 = (props: SvgProps) => <Svg
  width='14'
  height='12'
  viewBox='0 0 14 12'
  fill='none'
  {...props}
>
  <Path
    d='M7.5 11.25L12.75 6M12.75 6L7.5 0.75M12.75 6L0.75 6'
    stroke={props.color ?? '#0058AD'}
    strokeWidth='1.5'
    strokeMiterlimit='10'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;

export default RightArrow12;
